(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filter-results')) {
    class FilterResults extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.baseUrl = this.dataset.baseUrl || window.location.pathname;
        this.onPop = this.onPop.bind(this);
        this.onOutside = this.onOutside.bind(this);
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('submit', this.onSubmit.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        window.addEventListener('popstate', this.onPop);
        document.addEventListener('click', this.onOutside);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPop);
        document.removeEventListener('click', this.onOutside);
      }

      paramsFrom(form) {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (value, key) {
          if (value !== '') params.append(key, value);
        });
        return params;
      }

      fromForm(form, target) {
        var params;
        if (form.hasAttribute('data-sort-form')) {
          params = new URLSearchParams(window.location.search);
          params.set('sort_by', target.value);
          var menu = form.querySelector('details');
          if (menu) menu.open = false;
        } else {
          params = this.paramsFrom(form);
          var current = new URLSearchParams(window.location.search);
          if (!params.has('sort_by') && current.get('sort_by')) params.set('sort_by', current.get('sort_by'));
        }
        params.delete('page');
        this.load(this.baseUrl + '?' + params.toString());
      }

      onChange(event) {
        var form = event.target.closest('[data-filter-form], [data-sort-form]');
        if (!form || event.target.hasAttribute('data-price-input')) return;
        this.fromForm(form, event.target);
      }

      onInput(event) {
        if (!event.target.hasAttribute('data-price-input')) return;
        var form = event.target.closest('[data-filter-form]');
        var self = this;
        clearTimeout(this.priceTimer);
        this.priceTimer = setTimeout(function () { self.fromForm(form, event.target); }, 700);
      }

      onSubmit(event) {
        var form = event.target.closest('[data-filter-form], [data-sort-form]');
        if (!form) return;
        event.preventDefault();
        this.fromForm(form, event.submitter || form);
      }

      onClick(event) {
        var link = event.target.closest('[data-filter-link]');
        if (link) {
          event.preventDefault();
          this.load(link.href);
          return;
        }
        var apply = event.target.closest('[data-sheet-apply]');
        if (apply) {
          event.preventDefault();
          var dialog = apply.closest('dialog');
          if (dialog && window.Aroma) window.Aroma.closeDialog(dialog);
          else if (dialog) dialog.close();
          var results = this.querySelector('[data-swap="results"]');
          if (results) results.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        var menu = event.target.closest('.sort-menu[open]');
        if (menu) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      }

      onOutside(event) {
        this.querySelectorAll('.sort-menu[open]').forEach(function (menu) {
          if (!menu.contains(event.target)) menu.open = false;
        });
      }

      onPop() {
        this.load(window.location.href, false);
      }

      load(url, updateHistory) {
        var self = this;
        var target = new URL(url, window.location.origin);
        target.searchParams.delete('section_id');
        var fetchUrl = new URL(target.href);
        fetchUrl.searchParams.set('section_id', this.sectionId);
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        return fetch(fetchUrl.href, { signal: this.controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            self.swap(new DOMParser().parseFromString(html, 'text/html'));
            if (updateHistory !== false) window.history.replaceState({}, '', target.pathname + target.search);
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') window.location.href = target.href;
          })
          .finally(function () {
            self.classList.remove('is-loading');
            self.removeAttribute('aria-busy');
          });
      }

      swap(doc) {
        var active = document.activeElement;
        this.querySelectorAll('[data-swap]').forEach(function (region) {
          var key = region.getAttribute('data-swap');
          var fresh = doc.querySelector('[data-swap="' + key + '"]');
          if (!fresh) return;
          if (region.contains(active) && active.matches('input[type="number"], input[type="text"], input[type="search"]')) return;
          var focusedId = region.contains(active) ? active.id : null;
          var openStates = {};
          region.querySelectorAll('details[id]').forEach(function (details) { openStates[details.id] = details.open; });
          region.innerHTML = fresh.innerHTML;
          region.hidden = fresh.hidden;
          Object.keys(openStates).forEach(function (id) {
            var details = document.getElementById(id);
            if (details) details.open = openStates[id];
          });
          if (focusedId) {
            var next = document.getElementById(focusedId);
            if (next) next.focus({ preventScroll: true });
          }
        });
        if (window.AromaMotion) window.AromaMotion.init(this);
      }
    }
    customElements.define('filter-results', FilterResults);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-toc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('page-toc')) {
    customElements.define('page-toc', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this), { once: true });
          return;
        }
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        var content = document.querySelector(this.dataset.content);
        if (!content) return;
        var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
        if (headings.length < 2) return;
        var list = this.querySelector('ol');
        var used = {};
        var links = [];
        headings.forEach(function (heading, index) {
          if (!heading.id) {
            var base = heading.textContent.trim().toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '') || 'section-' + (index + 1);
            var id = base;
            var n = 2;
            while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
            used[id] = true;
            heading.id = id;
          }
          var item = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          link.className = 'page-toc__link';
          item.appendChild(link);
          list.appendChild(item);
          links.push(link);
        });
        this.hidden = false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.addEventListener('click', function (event) {
          var link = event.target.closest('a[href^="#"]');
          if (!link) return;
          var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          if (history.replaceState) history.replaceState(null, '', link.hash);
        });
        if (!('IntersectionObserver' in window)) return;
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (link) {
              var active = link.hash === '#' + entry.target.id;
              link.classList.toggle('is-active', active);
              if (active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        headings.forEach(function (heading) { observer.observe(heading); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
